import script from "./SfxImageViewOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxImageViewOverlay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCarouselSlide,QImg,QCarousel,QIcon,QCarouselControl,QList});
